import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UrlSignature } from '../common/apiEndpoint';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Applicants } from './Applicants';
import { AcademicYear } from './AcademicYear';
import { Response } from './Response';

@Injectable()
export class AllApplicantsService {
  constructor(
    private httpClient: HttpClient,
    private urlSignature: UrlSignature,
  ) {}

  getAllApplicants(year: string): Observable<Applicants[]> {
    const url = this.urlSignature.applicantListUrl + year;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Applicants[]));
  }

  getAcademicYears(): Observable<AcademicYear[]> {
    const url = this.urlSignature.academicYeartUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as AcademicYear[]));
  }

  getCurrentYear(): Observable<Response> {
    const url = this.urlSignature.currentYearUrl;
    return this.httpClient
      .get(url)
      .pipe(map((response) => response as Response));
  }

  getAllApplicantsExcelFile(year: string): Observable<Blob> {
    const url = this.urlSignature.excelUrl + '/' + year;
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  getAllAcceptedApplicantsExcelFile(year: string): Observable<Blob> {
    const url = this.urlSignature.excelAcceptedUrl + '/' + year;
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  getApplicantPDFFile(personId: string): Observable<Blob> {
    const url = this.urlSignature.pdfUrl + '/' + personId;
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  getAllRegisteredApplicantsExcelFile(year: string): Observable<Blob> {
    const url = this.urlSignature.excelRegisteredUrl + '/' + year;
    return this.httpClient.get(url, { responseType: 'blob' });
  }
}
